import {
  createElement,
  CSSProperties,
  ReactNode,
  RefObject,
  useImperativeHandle,
  useState,
} from 'react';
import { BadgeButton } from '../../BadgeButton';
import { DragPreview } from '../../../dnd/view/DragPreview';
import cn from '../Table.css.json';
import '../Table.css';

export interface DraggableRowRef {
  updateContent(children?: Array<ReactNode>): void;
}

export const DraggableRow = (props: {
  children?: ReactNode;
  numberOfRows?: number;
  rowProps?: any;
  className?: string;
  style?: CSSProperties;
  dragRowRef?: RefObject<DraggableRowRef | null | undefined>;
}) => {
  const dragCount = props.numberOfRows ?? -1;
  const [internalChildren, setInternalChildren] = useState(props.children);
  useImperativeHandle(
    props.dragRowRef,
    () => ({
      updateContent: (children?: Array<ReactNode>) => {
        setInternalChildren(children);
      },
    }),
    []
  );

  if (!internalChildren) return null;
  const multipleLayers = dragCount > 1;

  return (
    <DragPreview style={props.style} className={cn.ghost}>
      {multipleLayers ? <div className={cn.ghostBottom} /> : null}
      <div className={cn.ghostTop}>{internalChildren}</div>
      {multipleLayers ? (
        <BadgeButton className={cn.rowCount} value={dragCount} badgeDesign="square" />
      ) : null}
    </DragPreview>
  );
};
